import { render, staticRenderFns } from "./TestBuilding.vue?vue&type=template&id=15aecc44"
import script from "./TestBuilding.vue?vue&type=script&lang=js"
export * from "./TestBuilding.vue?vue&type=script&lang=js"
import style0 from "./TestBuilding.vue?vue&type=style&index=0&id=15aecc44&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports